import React, {Component} from 'react';

class PopupQtyMin extends Component {
    constructor(props) {
        super(props)
        this.handlePopupQtyMin = this.handlePopupQtyMin.bind(this);
    }

    handlePopupQtyMin() {
        this.props.inactivePopupQtyMin(false)
    }

    render() {
        return (
            <div id="popup-hair" className="slickModal isActive"
                 style={{"transition-duration": "0.4s"}}>
                <div className="slickOverlay closeModal setSlickCookie"
                     style={{'background': 'rgba(0, 0, 0, 0.85098)', 'transition-duration': '0.4s'}}></div>
                <div className="slickWindow center animated" style={{
                    'text-align': 'center',
                    'width': '337',
                    'height': '315px',
                    'box-shadow': 'rgba(0, 0, 0, 0.4) 0px 0px 20px 0px',
                    'background': 'rgb(255, 255, 255)',
                    'border-radius': '0px',
                    'margin': 'auto',
                    'padding': '0px',
                    'animation-duration': '0.4s',
                    'animation-delay': '0.2'
                }}>
                    <div className="slickCloseBtn close closeModal icon"
                         onClick={this.handlePopupQtyMin}
                    ></div>
                    <div className="wrap">
                        <div className="popup-icon"></div>
                        <h2>Stylu Service Minimum</h2>
                        <div className="stylulist">
                            <strong>
                              <p>
                                We require a two service minimum at the time of scheduling.
                              </p>
                              <p>&nbsp;</p>
                              <p>
                                If you have any questions or need any further information 
                                please email us at info@gostylu.com
                              </p>
                              <p>&nbsp;</p>
                              <p>
                                Thank you!
                              </p>
                            </strong>
                        </div>
                    </div>
                    <div className="cta" style={{'display': 'none'}}>
                        <span className="closeModal">Close me</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default PopupQtyMin;



/** WEBPACK FOOTER **
 ** ./src/components/PopupQtyMin.js
 **/